<template>
    <Layout>
        <div class="max-w-4xl mx-auto text-center pt-8">
            <h1 class="text-3xl text-left pl-4">Accounting Reports</h1>
            <br>
            <div class="text-left pl-4">
                <ul>
                    <li class="list-disc" v-for="download in accountingReports" :key="download.id">
                        <h1 class="text-xl font-bold pb-4">{{ download.title }} <a class="underline text-blue-600 hover:text-blue-800" target="_blank" :href="download.downloadForm?.data?.attributes?.url">(PDF)</a></h1> 
                        <p class="text-l pb-4">{{ download.description }}</p>
                    </li>
                </ul>
            </div>
        </div>
    </Layout>
</template>
<script>
import Layout from './../layouts/LayoutView.vue'
import axiosInstance from '@/utils/axiosInstance';


export default {
  components: {
    Layout
  },
  data() {
    return {
        accountingReports: [],
    };
  },
  computed: {
  },
    async created() {
    try {
      const response = await axiosInstance.get('accounts-page?populate[AccountReports][populate]=*'); 
      console.log(response)
      var responseAttributes = response.data.data.attributes;
      this.accountingReports = responseAttributes.AccountReports;
    } catch (error) {
      console.error('Failed to fetch About Us Page:', error);
      
    }
  },
}
</script>
